export const radii = {
  small: '5px',
  medium: '7px',
  large: '9px',
  extralarge: '12px',
  full: '100px',
}
